const stats = [
  { value: "$89", label: "Diagnostic Call" },
  { value: "Same-Day", label: "Most Repairs" },
  { value: "30-Day", label: "Workmanship Guarantee" },
  { value: "12", label: "Miami-Dade Areas" },
];

export default function StatsSection() {
  return (
    <section className="w-full bg-primary py-10">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <div className="text-3xl md:text-[48px] font-black text-white mb-1">
                {s.value}
              </div>
              <div className="text-sm text-[#fefce8]">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}